export default {
  header: 'Waitlist',
  'only-this-day': 'only this day',
  'plus-minus-one-day': '+/- 1 day',
  'any-staffer': 'Any Staff Member',
  'waitlist-empty': 'No clients on the waitlist',
  'waitlist-count': '{count} client on waitlist | {count} clients on waitlist | {count} clients on waitlist',
  'how-it-works': {
    'action-button': 'How it works',
    'template': {
      'title': 'How does Waitlist work?',
      'content': {
        'text': 'Clients can sign up for the Waitlist using the Booksy for Customers app. If they want to schedule an appointment on a day when you’re fully booked, they can select a convenient time range and sign up for the Waitlist. Optionally, they can check a relevant box on the Waitlist form, to let you know they are available a day before or after the selected date. The Waitlist view in Booksy will help you keep track of all clients who have signed up for the Waitlist.<br /><br />When a time slot becomes available (for example if a booking gets canceled or you change your business hours), all clients from the Waitlist will receive a text message informing them that you have openings.<br /><br />The message will include a direct link to your Booksy Profile to help them book quickly - available time slots are not pre-booked for clients from the Waitlist.',
      },
    },
  },
}
